import { fetchJarvisWeather, JarvisWeatherResult } from '@/services/jarvisWeatherService';

export type ConsolidatedWeatherData = JarvisWeatherResult;

export const fetchWeather = async (location: string, opts: { autoDetect?: boolean } = {}): Promise<ConsolidatedWeatherData> => {
  const data = await fetchJarvisWeather(location);
  if (!data) {
    throw new Error(`Failed to fetch weather data for ${location}`);
  }
  return data;
};



